<template>
    <Modal ref="modal" class="new-comment-modal" :close-on-backdrop-click="false" @closed="onCloseModal">
        <template #button="sp">
            <slot name="button" :show-modal="sp.showModal"></slot>
        </template>
        <template #header>
            <div class="h3">Nouveau commentaire</div>
        </template>
        <template #body="sp">
            <label for="new-comment-modal-textarea">Ecrivez votre commentaire</label>

            <textarea id="new-comment-modal-textarea" v-model="lMessage" rows="5"></textarea>

            <div class="form-check border border-danger bg-light py-2 pl-5 mb-2">
                <input class="form-check-input" type="checkbox" id="new-comment-modal-public-cb" v-model="lPublic">
                <label class="form-check-label" for="new-comment-modal-public-cb">
                    <i class="fad fa-fw fa-eye"></i> Cocher cette case pour rendre ce commentaire visible par le client (sera affiché sur le BL/Récap)
                </label>
            </div>

            <div class="form-check border bg-light py-2 pl-5">
                <input class="form-check-input" type="checkbox" id="new-comment-modal-production-slip-cb" v-model="lProductionSlip">
                <label class="form-check-label" for="new-comment-modal-production-slip-cb">
                    <i class="fad fa-fw fa-clipboard-list-check"></i> Cocher cette case pour afficher ce commentaire sur les bons de fabrication
                </label>
            </div>

            <ErrorsZone :errors="errors" class="mt-2 mb-0" />

            <div class="d-flex justify-content-between">
                <button class="btn btn-secondary mt-2" @click="closeModal" :disabled="sending">
                    Fermer
                </button>
                <button class="btn btn-outline-success mt-2" @click="onSubmit" :disabled="sending || !canSave">
                    <template v-if="sending"><i class="fad fa-spin fa-spinner"></i> Enregistrement en cours</template>
                    <template v-else><i class="fad fa-save"></i> Enregistrer</template>
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
import ErrorsZone from "./ErrorsZone"
import Modal from "./Modal"

import {usePostRequest} from "./compositions/axios/postRequest"

export default {
    name: 'NewCommentModal',

    components: {
        Modal,
        ErrorsZone,
    },

    props: {
        commentableType: {
            required: true,
        },
        commentableId: {
            required: true,
        },
        message: {
            type: String,
            required: false,
        },
        public: {
            type: Boolean,
            required: false,
        },
        productionSlip: {
            type: Boolean,
            required: false,
        },
    },

    setup(props) {
        const {
            loading: sending,
            errors,
            post: send,
        } = usePostRequest();

        return {
            sending,
            errors,
            send,
        };
    },

    data() {
        return {
            lMessage: this.message || '',
            lPublic: this.public || false,
            lProductionSlip: this.productionSlip || false,
        }
    },

    computed: {
        canSave() {
            return _.trim(this.lMessage).length > 0;
        },
    },

    methods: {
        async onSubmit() {
            if (this.lPublic && !confirm("Le client pourra voir ce message. Confirmez-vous l'ajout du commentaire ?")) {
                return;
            }

            let response = await this.send('/espace-employes/commentaires', {
                commentable_type: this.commentableType,
                commentable_id: this.commentableId,
                message: this.lMessage,
                public: this.lPublic,
                production_slip: this.lProductionSlip,
            });

            if (response && response.success) {
                this.lMessage = '';
                this.lPublic = false;
                if (response.redirect) {
                    window.location = response.redirect;
                }
                this.closeModal();
            }
        },

        showModal() {
            this.$refs.modal.showModal();
        },

        closeModal() {
            this.$refs.modal.closeModal();
        },

        onCloseModal() {
            this.lPublic = false;
            this.lProductionSlip = false;
            this.lMessage = '';
            this.$emit('closed');
        },
    },
}
</script>

<style lang="scss">
.new-comment-modal {
    textarea {
        width: 100%;
    }

    .modal-container {
        max-width: 900px;
        width: auto;
    }
}
</style>
